import type {FC, SelectHTMLAttributes} from 'react'

interface Option {
  label: string
  value: string | number
}

interface Props {
  options: Array<Option>
  label: string
}

const SelectDefault: FC<Props & SelectHTMLAttributes<HTMLSelectElement>> = ({
  options,
  label,
  className,
  ...props
}) => {
  return (
    <select {...props} className={className || 'form-select'} aria-label={label}>
      <option value='' disabled>
        Select {label}
      </option>
      {options.map((option, index) => (
        <option key={index} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  )
}

export default SelectDefault
